import type { CurrentRead } from '@signalvote/data';
import type { ComplianceProfileDto } from '@signalvote/shared';

/** The compliance profile read; null data means the campaign has no ruleset assigned yet. */
export type ComplianceProfileRead = CurrentRead<ComplianceProfileDto | null>;

/** The profile once its read has answered; undefined while it loads, has not run, or could not answer. */
export function readyProfile(read: ComplianceProfileRead): ComplianceProfileDto | null | undefined {
  return read.status === 'ready' ? read.data : undefined;
}

/** What to say in place of a choice the profile decides when its read could not answer; null otherwise. */
export function profileUnreadyMessage(read: ComplianceProfileRead): string | null {
  if (read.status === 'offline') return "You're offline, so your jurisdiction's filing rules can't load.";
  if (read.status === 'failed') return "Couldn't load your jurisdiction's filing rules. Refresh to try again.";
  return null;
}
